import { render, staticRenderFns } from "./CrumbsDropdownItem.vue?vue&type=template&id=5d46762f&"
import script from "./CrumbsDropdownItem.vue?vue&type=script&lang=js&"
export * from "./CrumbsDropdownItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports